import { createFileRoute } from "@tanstack/react-router";

import { PraxaOrganizationPeople } from "../components/praxa/PraxaOrganizationPeopleSurface";

export const Route = createFileRoute("/w/$workspaceId/people/")({
  component: PraxaOrganizationPeopleRoute,
});

function PraxaOrganizationPeopleRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaOrganizationPeople workspaceId={workspaceId} />;
}
